import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApptDtlCardModule } from '../appt-dtl-card/appt-dtl-card.module';
import { AltpaymentInputModule } from '../components/altpayment-input/altpayment-input.module';
import { DisplayCurrencyModule } from '../components/display-currency/display-currency.module';
import { PromoInputModule } from '../components/promo-input/promo-input.module';
import { CouponModalModule } from '../coupon-modal/coupon-modal.module';
import { CouponModule } from '../coupon/coupon.module';
import { HealthPackageDetailsModule } from '../health-package-details/health-package-details.module';
import { ManageIdentitiesModule } from '../manage-identities/manage-identities.module';
import { PaymentCheckoutModule } from '../payment-checkout/payment-checkout.module';
import { PersonAvatarModule } from '../person-avatar/person-avatar.module';
import { PipesModule } from '../pipes/pipes.module';
import { HealthPackageConfirmationComponent } from './health-package-confirmation.component';



@NgModule({
  declarations: [HealthPackageConfirmationComponent],
  imports: [
    CommonModule,
    PersonAvatarModule, 
    FormsModule,
    PipesModule,
    ManageIdentitiesModule,
    HealthPackageDetailsModule,
    PaymentCheckoutModule,
    ApptDtlCardModule,
    CouponModule,
    CouponModalModule,
    PromoInputModule, AltpaymentInputModule, DisplayCurrencyModule
  ],
  exports: [
    HealthPackageConfirmationComponent
  ]
})
export class HealthPackageConfirmationModule { }
